import {cloneDeep} from "lodash";
import {getString} from "Core/helpers/data";
import {ExternalQuestionnairesListItemDataObject} from "../dataObjects";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {ExternalQuestionnairesListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new ExternalQuestionnairesListItemDataObject(
		getString(result, 'id'),
		getString(result, 'abmAccountId'),
		getString(result, 'name'),
	);

	return result;
}

// @note: There is no output function since list is read-only.